import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaitofivejyotilingacab() {



const cardData = {
  keyword: " Navi Mumbai to 5 Jyotirlinga Darshan Cab",

headingDescription:
"Omshree Cab offers reliable and comfortable Navi Mumbai to 5 Jyotirlinga Darshan cab services for travelers planning a spiritual journey to some of the most revered Shiva temples in India. The 5 Jyotirlinga Yatra typically includes temples such as Trimbakeshwar, Grishneshwar, Bhimashankar, Aundha Nagnath, and Omkareshwar, located across Maharashtra and Madhya Pradesh. Whether you are undertaking a religious pilgrimage, family trip, or group spiritual tour, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. The total distance for visiting all five Jyotirlingas from Navi Mumbai varies between 1,100–1,300 km, often requiring multi-day travel. We provide flexible booking options including one-way trips, round-trip packages, and multi-day plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs experienced in long-distance and highway driving, punctual pickups from any location in Navi Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai to 5 Jyotirlinga Darshan cab booking.",

topPlaces: [
{
title: "Trimbakeshwar Jyotirlinga",
description:
"Trimbakeshwar Jyotirlinga, located near Nashik, is one of the most sacred Shiva temples in India and is known for its spiritual significance and ancient architecture. Pilgrims visit to perform rituals, take holy dips in the Godavari River, and experience the serene and devotional atmosphere. Traveling by cab from Navi Mumbai allows devotees to comfortably reach this revered temple and plan their pilgrimage efficiently."
},
{
title: "Grishneshwar Jyotirlinga",
description:
"Grishneshwar Jyotirlinga is situated near Ellora in Aurangabad and is famed for its beautiful carvings, historic importance, and peaceful surroundings. Pilgrims come here to offer prayers, participate in religious ceremonies, and admire the intricate temple architecture. A cab journey from Navi Mumbai ensures convenient and comfortable travel to this sacred site as part of the Jyotirlinga tour."
},
{
title: "Bhimashankar Jyotirlinga",
description:
"Bhimashankar Jyotirlinga is located in the Western Ghats and is surrounded by lush forests and hills. This temple is not only a religious destination but also a nature lover’s delight, offering trekking opportunities and scenic views. Travelers can enjoy the spiritual ambiance as well as the natural beauty of the area. Using a cab from Navi Mumbai provides safe and hassle-free access to this remote but important Jyotirlinga."
},
{
title: "Aundha Nagnath Jyotirlinga",
description:
"Aundha Nagnath Jyotirlinga, located in Hingoli district, Maharashtra, is an ancient temple dedicated to Lord Shiva with significant historical and religious importance. Visitors come here to perform prayers, attend rituals, and experience the serene temple surroundings. A cab service from Navi Mumbai allows pilgrims to reach this site comfortably and incorporate it efficiently into their multi-day pilgrimage."
},
{
title: "Omkareshwar Jyotirlinga",
description:
"Omkareshwar Jyotirlinga, located on an island in the Narmada River in Madhya Pradesh, is one of the holiest Shiva temples in India. Devotees visit to perform prayers, rituals, and take in the scenic river surroundings. Traveling by cab from Navi Mumbai allows pilgrims to include this distant but spiritually important destination in their Jyotirlinga yatra without worrying about transport or logistics."
}
],



services: [
{
name: "Navi Mumbai to 5 Jyotirlinga Cab",
description: "Navi Mumbai to 5 Jyotirlinga cab service provides comfortable pilgrimage travel for devotees visiting the sacred Jyotirlinga temples of Lord Shiva. The popular 5 Jyotirlinga tour from Navi Mumbai usually includes Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Our cab service offers comfortable sedans, SUVs, and spacious MPV vehicles suitable for long spiritual journeys. Professional drivers ensure safe driving and convenient temple visits throughout the pilgrimage route. Families and devotees can travel peacefully with flexible travel schedules. Air-conditioned vehicles and ample luggage space make the journey comfortable. The service ensures a smooth and well-organized Jyotirlinga darshan tour."
},
{
name: "5 Jyotirlinga Darshan Cab Navi Mumbai",
description: "5 Jyotirlinga darshan cab Navi Mumbai offers reliable temple tour transportation for devotees planning the sacred Shiva pilgrimage. The cab allows passengers to comfortably visit multiple Jyotirlinga temples across Maharashtra and nearby regions. Professional drivers ensure safe highway travel and convenient temple stops during the journey. Vehicles provide spacious seating and smooth ride quality suitable for long-distance travel. Families, devotees, and spiritual groups enjoy relaxed travel with flexible darshan schedules. The service ensures comfortable and peaceful pilgrimage journeys. Travelers experience dependable transportation throughout the temple tour."
},
{
name: "Jyotirlinga Tour Cab Navi Mumbai",
description: "Jyotirlinga tour cab Navi Mumbai provides complete pilgrimage travel for devotees wishing to explore the holy Shiva temples. The cab service covers major Jyotirlinga temples with convenient travel planning and comfortable vehicles. Professional drivers ensure efficient travel routes and safe highway driving. Passengers enjoy comfortable seating, powerful AC cooling, and spacious interiors during the journey. The service is ideal for family pilgrimage trips and spiritual travel groups. Travelers can complete their temple visits comfortably and peacefully. It is a reliable option for Jyotirlinga temple tours."
},
{
name: "Shiva Temple Tour Cab Navi Mumbai",
description: "Shiva temple tour cab Navi Mumbai offers convenient transportation for devotees visiting multiple Lord Shiva temples during pilgrimage journeys. The service allows travelers to visit sacred Jyotirlinga temples with comfortable road travel. Vehicles provide spacious seating and smooth highway performance for long journeys. Professional drivers ensure punctual pickups and safe travel throughout the tour. Families and groups enjoy peaceful travel with well-planned temple visits. The service supports both short and multi-day pilgrimage trips. Devotees experience comfortable spiritual travel."
},
{
name: "Navi Mumbai Jyotirlinga Cab Service",
description: "Navi Mumbai Jyotirlinga cab service provides reliable temple tour transportation for devotees visiting sacred Shiva shrines. The service includes comfortable sedans, SUVs, and MPV vehicles suitable for long-distance pilgrimage travel. Professional drivers ensure safe driving and convenient temple stops throughout the journey. Travelers enjoy spacious interiors and air-conditioned comfort during the tour. The service is ideal for families, senior citizens, and spiritual groups. Devotees can complete their darshan comfortably with flexible travel plans. It offers dependable pilgrimage transportation."
},
{
name: "Navi Mumbai Jyotirlinga Taxi Service",
description: "Navi Mumbai Jyotirlinga taxi service provides comfortable road transportation for devotees planning Shiva temple darshan tours. The taxi service allows travelers to visit sacred Jyotirlinga temples conveniently. Vehicles offer comfortable seating and smooth highway performance for long-distance journeys. Professional drivers ensure punctual pickup and safe driving during the pilgrimage. Families and groups enjoy convenient temple travel without transportation worries. The service ensures reliable and peaceful pilgrimage journeys. Travelers benefit from comfortable and organized temple tours."
},
{
name: "Navi Mumbai to Jyotirlinga Cab Booking",
description: "Navi Mumbai to Jyotirlinga cab booking allows devotees to easily reserve vehicles for spiritual temple tours. Customers can select sedans, SUVs, or spacious MPV vehicles depending on group size and travel preferences. Online and phone booking options provide quick confirmation for pilgrimage trips. Professional drivers ensure safe travel and convenient temple visits. The service offers flexible travel schedules for comfortable darshan. Vehicles provide air-conditioned interiors and reliable highway performance. Devotees enjoy simple and convenient booking for temple tours."
},
{
name: "Navi Mumbai to Jyotirlinga Taxi Booking Online",
description: "Navi Mumbai to Jyotirlinga taxi booking online provides quick digital reservations for travelers planning temple pilgrimage tours. Passengers can easily schedule taxis online and receive instant booking confirmation. Vehicles provide comfortable seating and reliable ride quality for long journeys. Professional drivers ensure punctual pickups and safe driving throughout the pilgrimage route. The service is suitable for families, devotees, and group travelers. Online booking simplifies travel planning and saves time. Travelers enjoy hassle-free pilgrimage transportation."
},
{
name: "Jyotirlinga Tour Taxi Navi Mumbai",
description: "Jyotirlinga tour taxi Navi Mumbai offers dependable road transportation for devotees visiting sacred Shiva temples. The taxi provides comfortable seating and reliable highway performance for long-distance travel. Professional drivers ensure safe driving and efficient travel routes between temples. Families and pilgrimage groups enjoy relaxed journeys with convenient temple stops. The vehicles provide air-conditioned comfort and smooth ride quality. Travelers can complete their spiritual journey comfortably. The taxi service provides reliable transportation for temple tours."
},
{
name: "Jyotirlinga Temple Darshan Cab",
description: "Jyotirlinga temple darshan cab provides dedicated transportation for devotees visiting sacred Lord Shiva temples. The cab allows travelers to complete their darshan comfortably with flexible travel schedules. Vehicles offer spacious seating and smooth highway travel suitable for long journeys. Professional drivers ensure safe driving and convenient temple visits. Families and groups can travel peacefully throughout the pilgrimage. Air-conditioned vehicles and comfortable interiors enhance the journey. The service ensures reliable and comfortable spiritual travel."
}
],

tableData: [
["Navi Mumbai to 5 Jyotirlinga Cab","5 Jyotirlinga Darshan Cab Navi Mumbai"],
["Jyotirlinga Tour Cab Navi Mumbai","Shiva Temple Tour Cab Navi Mumbai"],
["Navi Mumbai Jyotirlinga Cab Service","Navi Mumbai Jyotirlinga Taxi Service"],
["Navi Mumbai to Jyotirlinga Cab Booking","Navi Mumbai to Jyotirlinga Taxi Booking Online"],
["Jyotirlinga Tour Taxi Navi Mumbai","Jyotirlinga Temple Darshan Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are experienced in long-distance religious tours including the famous 5 Jyotirlinga Darshan route from Navi Mumbai. They are familiar with temple locations, highway routes, and pilgrimage travel needs ensuring a smooth spiritual journey."
  },
  {
    WhyChooseheading: "Transparent Darshan Travel Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai to 5 Jyotirlinga Darshan cab bookings. Customers receive clear information about total package cost, per-kilometer fare, toll charges, and driver allowance before confirming the trip."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Jyotirlinga Darshan cab service from Navi Mumbai operates 24 hours a day. Travelers can start their spiritual journey early morning, overnight, or anytime according to temple schedules."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to ensure pilgrims enjoy a comfortable and peaceful travel experience during long-distance temple tours."
  },
  {
    WhyChooseheading: "Flexible Religious Tour Packages",
    WhyChoosedescription: "We provide flexible pilgrimage travel packages including multi-day 5 Jyotirlinga Darshan tours with customizable routes, temple stops, and accommodation breaks."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group pilgrims traveling together."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, apartments, hotels, and residential societies anywhere in Navi Mumbai so pilgrims can begin their spiritual journey comfortably."
  },
  {
    WhyChooseheading: "Trusted Religious Tour Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai to 5 Jyotirlinga Darshan trips thanks to our punctual drivers, comfortable vehicles, and reliable long-distance service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Navi Mumbai for 5 Jyotirlinga Darshan?", answer: "Yes, Omshree Cabs provides dedicated cab packages for 5 Jyotirlinga Darshan tours starting from Navi Mumbai." },
  { question: "Which Jyotirlinga temples are included in this route?", answer: "Popular 5 Jyotirlinga tours usually include Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath." },
  { question: "How many days are required for 5 Jyotirlinga Darshan?", answer: "Most pilgrims complete the 5 Jyotirlinga Darshan trip in approximately 3 to 5 days depending on the travel plan." },
  { question: "Which vehicles are available for this pilgrimage trip?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers depending on the group size." },
  { question: "Can we customize the pilgrimage route?", answer: "Yes, customers can customize the temple visit order, travel stops, and rest breaks according to their travel plan." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our pilgrimage cab service operates 24/7 for flexible travel schedules." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long journeys." },
  { question: "Can we stop for meals or rest during the journey?", answer: "Yes, passengers can request stops for meals, refreshments, or rest breaks during the trip." },
  { question: "Is advance booking recommended for Jyotirlinga trips?", answer: "Yes, advance booking is recommended especially during festival seasons and religious holidays." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vijay Kulkarni",
    feedback:
      "We booked Omshree Cabs for our Navi Mumbai to 5 Jyotirlinga Darshan trip. The driver was very experienced and the journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Patil",
    feedback:
      "Our family pilgrimage trip was wonderful with Omshree Cabs. Clean vehicle, professional driver, and well-planned temple visits.",
    rating: 5
  }
];







































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab provides safe and comfortable cab services from Navi Mumbai to 5 Jyotirlinga temples. Ideal for Shiva temple tours and pilgrimage trips, we offer Innova cabs and flexible one-way or round-trip bookings for a seamless darshan experience.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Navi Mumbai to 5 Jyotirlinga Cab",
    "Jyotirlinga Temple Darshan Cab",
    "Shiva Temple Tour Cab",
    "One Way Cab",
    "Round Trip Taxi",
    "Innova Cab",
    "Pilgrimage Cab Service"
  ]
};








  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai to 5 Jyotirlinga Darshan Cab | Omshree Cab</title>
  <meta
    name="description"
    content="Book a reliable cab from Navi Mumbai to 5 Jyotirlinga temples with Omshree Cab. Comfortable Innova cabs for one-way or round-trip Shiva temple tours, ensuring a safe and smooth darshan experience."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitofivejyotilingacab;